<template>
  <div>
    <a-upload
      name="file"
      :fileList="fileList"
      :beforeUpload="beforeUpload"
      @change="handleChange"
      :remove="remove"
      accept=".xlsx, .xls, .csv"
    >
      <a-button>
        <a-icon type="upload"/>
        Subir archivo
      </a-button>
    </a-upload>
    <br>
    <a-button
      type="primary"
      :loading="loading"
      @click="subirArchivo"
      :disabled="fileList.length === 0"
    >
      <a-icon type="up-circle"/>
      Procesar Archivo
    </a-button>

    <a-tabs defaultActiveKey="1" style="margin-top: 20px">
      <a-tab-pane key="1">
        <span slot="tab">
          <a-icon type="file-excel"/>
          Resultado del Procesamiento
        </span>

        <div v-if="loading">
          <a-spin tip="Procesando archivo..."/>
        </div>

        <div v-else>
          <a-result
            v-if="result.status === 'success'"
            status="success"
            :title="result.message"
            :subTitle="`Registros creados: ${result.created_records}`"
          >
            <template #extra>
              <div v-if="result.warnings && result.warnings.length > 0">
                <a-alert type="warning" showIcon style="margin-bottom: 10px">
                  <div slot="message">
                    <strong>Advertencias:</strong>
                    <ul style="margin-bottom: 0">
                      <li v-for="(warning, idx) in result.warnings" :key="'warn-'+idx">
                        {{ warning }}
                      </li>
                    </ul>
                  </div>
                </a-alert>
              </div>
            </template>
          </a-result>

          <div v-if="result.status === 'error'">
            <a-result
              status="error"
              :title="result.message"
              :subTitle="`Errores encontrados: ${result.errors.length}`"
            >
              <template #extra>
                <a-alert type="error" showIcon style="margin-bottom: 10px">
                  <div slot="message">
                    <strong>Errores que deben corregirse:</strong>
                    <ul style="margin-bottom: 0">
                      <li v-for="(error, idx) in result.errors" :key="'err-'+idx">
                        {{ error }}
                      </li>
                    </ul>
                  </div>
                </a-alert>

                <div v-if="result.warnings && result.warnings.length > 0">
                  <a-alert type="warning" showIcon>
                    <div slot="message">
                      <strong>Advertencias:</strong>
                      <ul style="margin-bottom: 0">
                        <li v-for="(warning, idx) in result.warnings" :key="'warn-'+idx">
                          {{ warning }}
                        </li>
                      </ul>
                    </div>
                  </a-alert>
                </div>
              </template>
            </a-result>
          </div>
          <a-collapse v-if="result.errors && result.errors.length > 0" :bordered="false">
            <a-collapse-panel key="1" header="Ver detalles de errores">
              <a-tree :autoExpandParent="true" :defaultExpandAll="true">
                <a-tree-node v-for="(error, index) in result.errors" :key="index">
                  <span slot="title">
                    <a-tag color="#e53935">Error {{index + 1}}</a-tag>
                    {{ error }}
                  </span>
                </a-tree-node>
              </a-tree>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab">
          <a-icon type="snippets"/>
          Historico De Cargues Ocasionales
        </span>
        <cargue-historico-oca @loadData="loadData" ref="hist"/>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data() {
      return {
        fileList: [],
        loading: false,
        result: {
          status: '',
          message: '',
          created_records: 0,
          errors: [],
          warnings: []
        }
      }
    },
    methods: {
      loadData () {
        this.$emit('loadData')
      },
      beforeUpload(file) {
        const isExcel = file.type.includes('excel') ||
          file.type.includes('spreadsheet') ||
          file.name.endsWith('.xlsx') ||
          file.name.endsWith('.xls') ||
          file.name.endsWith('.csv')
        const isLt10M = file.size / 1024 / 1024 < 10

        if (!isExcel) {
          Mensajes.error('Error', 'Solo se permiten archivos Excel (.xlsx, .xls) o CSV')
          return false
        }

        if (!isLt10M) {
          Mensajes.error('Error', 'El tamaño del archivo no puede ser mayor a 10MB')
          return false
        }

        return false
      },

      handleChange({ file }) {
        if (file.status !== 'removed') {
          this.fileList = [file]
        } else {
          this.fileList = []
        }
      },

      remove() {
        this.fileList = []
        this.resetResult()
        return true
      },

      resetResult() {
        this.result = {
          status: '',
          message: '',
          created_records: 0,
          errors: [],
          warnings: []
        }
      },

      async subirArchivo() {
        if (this.fileList.length === 0) {
          Mensajes.error('Error', 'Debes seleccionar un archivo')
          return
        }

        this.loading = true
        this.resetResult()

        try {
          const formData = new FormData()
          formData.append('document', this.fileList[0])

          const httpClient = new HttpUtil().getNewInstance()
          httpClient.defaults.headers['Content-Type'] = 'multipart/form-data'

          const response = await httpClient.post('document_oca/uploadDynamic', formData)
          const data = response.data

          this.result = {
            status: data.status,
            message: data.message,
            created_records: data.created_records || 0,
            errors: data.errors || [],
            warnings: data.warnings || []
          }

          if (data.status === 'success') {
            Mensajes.success('Éxito', data.message)
          } else {
            Mensajes.error('Error', data.message)
          }
        } catch (error) {
          const errorMsg = (error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'No fue posible procesar el archivo'

          this.result = {
            status: 'error',
            message: errorMsg,
            created_records: 0,
            errors: (error.response && error.response.data && error.response.data.errors)
              ? error.response.data.errors
              : [errorMsg],
            warnings: (error.response && error.response.data && error.response.data.warnings)
              ? error.response.data.warnings
              : []
          }

          Mensajes.error('Error', errorMsg)
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
  .ant-upload {
    margin-bottom: 15px;
  }
  .ant-alert {
    margin-bottom: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/CargueDinamicoOcasionales.vue